import { Dropdown, DropdownProps } from "antd";
import styles from "./VLDropdown.module.scss";

export const VLDropdown = (props: DropdownProps) => (
  <Dropdown
    {...props}
    classNames={{ root: `${styles.VLDropdown} ${props.className ?? ""}` }}
  />
);
